import {
  delayWhen,
  filter,
  interval,
  merge,
  Observable,
  switchMap,
} from 'rxjs';
import {
  RegisterExtensionEditorSetup,
  RegisterExtensionRender,
} from './types/registerExtension';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DestroyRef, ElementRef, Injector, Signal } from '@angular/core';
import {
  DEFAULT_EXTENSIONS_EDITORFORMAT,
  DEFAULT_EXTENSIONS_EDITORSETUP,
  DEFAULT_EXTENSIONS_RENDERS,
} from './extensions';
import { Editor, EditorOptions, Formats } from 'tinymce';

export const registerExtensionsRender = (
  element: Signal<ElementRef<HTMLElement> | undefined>,
  update: Observable<any>,
  preview: Signal<boolean>,
  injector: Injector,
  extensions?: RegisterExtensionRender[]
) => {
  let destroy = injector.get(DestroyRef);
  return update
    .pipe(
      delayWhen((_, i) => interval(i === 0 ? 0 : 2000)),
      filter(() => !preview() && !!element()?.nativeElement),
      switchMap(() =>
        merge(
          ...DEFAULT_EXTENSIONS_RENDERS.map((fn) =>
            fn(element()?.nativeElement!, injector)
          ),
          ...(extensions ?? []).map((fn) =>
            fn(element()?.nativeElement!, injector)
          )
        )
      ),
      takeUntilDestroyed(destroy)
    )
    .subscribe();
};

export const registerExtensionsEditorSetup = (
  editor: Editor,
  injector: Injector,
  extensions?: RegisterExtensionEditorSetup[]
) => {
  DEFAULT_EXTENSIONS_EDITORSETUP.forEach((fn) => fn(editor, injector));
  (extensions ?? []).forEach((fn) => fn(editor, injector));
};

export const registerExtensionEditorFormat = (
  extensions?: EditorOptions['formats'][]
) => ({
  ...DEFAULT_EXTENSIONS_EDITORFORMAT,
  ...(extensions?.reduce((acc, cur) => ({ ...acc, ...cur }), {}) ?? {}),
});
